import React, { useRef } from 'react';
import { Modal, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Spinner from '../../../../components/Loaders/Spinner';
import Alert from '../../../../components/Alert';

const EditPaymentModal = ({ error, open, onHide, item, isLoading, isLoadingSubmit, methods, onSubmit }) => {
  const formNode = useRef(null);

  const onSubmitForm = () => {
    const current = formNode?.current;
    const formData = {
      method: current?.method?.value,
      memo: current?.memo?.value,
    };
    onSubmit?.(formData, 'edit');
  };

  return (
    <Modal show={open} onHide={onHide} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Edit payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert text={error} />}
        {isLoading ? (
          <div className="modal-loader-small" />
        ) : (
          <form ref={formNode} onSubmit={onSubmitForm}>
            <FormGroup>
              <ControlLabel>Method</ControlLabel>
              <FormControl componentClass="select" name="method" defaultValue={item.method_id}>
                {methods?.map((method) => (
                  <option key={method.id} value={method.id}>
                    {method.title}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Memo</ControlLabel>
              <FormControl type="text" name="memo" defaultValue={item.memo} />
            </FormGroup>
          </form>
        )}
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button bsStyle="primary" type="submit" disabled={isLoadingSubmit || isLoading} onClick={onSubmitForm}>
          {isLoadingSubmit && <Spinner />}
          <span>Edit payment</span>
        </Button>
        <Button
          onClick={() => {
            onHide();
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

EditPaymentModal.propTypes = {
  error: PropTypes.string,
  open: PropTypes.bool,
  item: PropTypes.object,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  methods: PropTypes.array,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default EditPaymentModal;
